import { render, staticRenderFns } from "./VariableHeaderDropdown.vue?vue&type=template&id=25ed2c3a"
import script from "./VariableHeaderDropdown.vue?vue&type=script&lang=js"
export * from "./VariableHeaderDropdown.vue?vue&type=script&lang=js"
import style0 from "./VariableHeaderDropdown.vue?vue&type=style&index=0&id=25ed2c3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports